import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from "@mui/material";

function BasicDialog({
    open,
    title,
    content,
    onClose,
    onSubmit,
    buttonLabel,
    maxWidth = "md",
    ...others
}) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth={true}
            maxWidth={maxWidth}
            scroll="paper"
            {...others}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent dividers={false}>
                <DialogContentText>{content}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button key="cancel" onClick={() => onClose()}>
                    Cancel
                </Button>
                <Button
                    key="save"
                    variant="contained"
                    color="primary"
                    disableElevation={true}
                    onClick={() => {
                        onSubmit();
                    }}
                >
                    {buttonLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default BasicDialog;
